import { withInstall } from '@hd-front-end/utils'
import Text from './src/text.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElText: SFCWithInstall<typeof Text> = withInstall(Text)
export default ElText

export * from './src/text'
